import { LoadingOverlay } from "@mantine/core";
import qs from "qs";
import React from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import { AuthApi, GeneralApi } from "../../apis";
import { authChange, authMe } from "../../store/Auth";
import { initGeneral } from "../../store/General";
import { message } from "../../utils/Message";

let __ACCESS_BOOTSTRAPPED__ = false;

export function Access() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  React.useEffect(() => {
    // Survives StrictMode remount. Do NOT depend on accessToken — authChange
    // would re-fire this effect and double-call init/me.
    if (__ACCESS_BOOTSTRAPPED__) return;
    __ACCESS_BOOTSTRAPPED__ = true;

    (async () => {
      try {
        const params = qs.parse(location.search);
        dispatch(authChange({ accessToken: params["?token"], sessionScope: "AUTHORIZED" } as any));

        const res = await GeneralApi.init();
        dispatch(initGeneral(res));
        const auth = await AuthApi.me();
        dispatch(authMe(auth));

        const redirect = typeof params.redirect === "string" ? params.redirect : null;
        const safeRedirect =
          redirect && redirect.startsWith("/") && !redirect.startsWith("//")
            ? redirect
            : "/";
        navigate(safeRedirect);
      } catch (err: any) {
        err?.message && message.error(err.message);
      }
    })();
  }, [dispatch, location.search, navigate]);

  return <LoadingOverlay visible />;
}
